/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { GeminiCardsSectionFragment } from "@cosmos/hygraph-schema";

import {
	BackgroundContainer,
	CosmosTextVariantEnum,
	LogoTitleDescButtonStack,
	ResponsiveContainer,
	SectingHeadingSizesEnum,
	SectionContainer,
} from "@components/elements";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { SystemStyleObject } from "@panda/types";

import { GeminiCards } from "./GeminiCards.molecule";

const styles: SystemStyleObject = {
	"&&": {
		smDown: {
			rowGap: "eds.dimension.40",
		},
	},
	"& .gemini-section-heading .heading": {
		smDown: {
			textStyle: "headingXL",
		},
	},
	"& .logo img": {
		height: "32px",
		width: "auto",
	},
};

export const GeminiCardsSection = ({
	config,
	title,
	desc,
	cards,
	logoImage,
	cardsVariant,
	gradient,
}: GeminiCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(title || desc || logoImage);
	const validContent = Boolean(cards?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack alignItems="stretch" gap="eds.dimension.48" className={cx("gemini-card-section", css(styles))}>
						{validHeading ? (
							<LogoTitleDescButtonStack
								animate={false}
								stack={{ gap: "eds.dimension.24" }}
								image={logoImage}
								titleDescStack={{
									stack: { gap: "eds.dimension.24", align: "start", maxWidth: SectingHeadingSizesEnum.md },
									title: { ...title, variant: "heading2XL", as: "h4" },
									gradient,
									description: {
										html: desc,
										variant: CosmosTextVariantEnum.paragraphMD,
										as: "div",
										color: "eds.text.secondary",
									},
									className: "gemini-section-heading",
								}}
							/>
						) : null}
						{validContent ? <GeminiCards cards={cards || []} cardsVariant={cardsVariant} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
